import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	chatChannelTitle: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.chat-channel-field.chat-channel-title',
		defaultMessage: 'Chat channel',
		description:
			'The subtitle heading for the Chat Channel section of the new incident management settings info card',
	},
	chatChannelDescription: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.chat-channel-field.chat-channel-description',
		defaultMessage:
			'Streamline your incident communications, collaborate efficiently, and take actions directly from your dedicated chat channel.',
		description:
			'The body text for the Chat Channel section of the incident management settings info card.',
	},
	chatChannelLearnMoreLink: {
		id: 'servicedesk-incident-management-settings.incident-management-fields.chat-channel-field.chat-channel-learn-more-link',
		defaultMessage: 'Learn how to create a chat channel.',
		description:
			'The learn more text for Chat Channel section of the incident management settings info card.',
	},
});
